import { useMemo } from 'react';
import moment from 'moment';
import { useSearchEntitiesQuery } from '../../../../api/useSearchEntitiesQuery';
import { useRouteParams } from '../../../../hooks/useRouteParams';
import { AsyncComponentHookResult } from '../../../../../Types/ComponentHookResult';
import { useBaseEntityList, UseEntityListActions } from '../../../../hooks/useBaseEntityList';
import { EntitiesDTO, EntityDTO } from '../../../../DocumentVault.meta';

type SearchEntityListData = Pick<EntitiesDTO, 'items'>;

export interface UseSearchEntityListParams {
  searchTerm: string;
}

export const useSearchEntityList = ({
  searchTerm,
}: UseSearchEntityListParams): AsyncComponentHookResult<SearchEntityListData, UseEntityListActions> & {
  isDownloadingFile: boolean;
  currentVideoEntity: EntityDTO | null;
} => {
  const { clientId, path, providerType, filterableByYear } = useRouteParams();
  const queryResult = useSearchEntitiesQuery({
    clientId,
    path,
    providerType,
    filterableByYear,
    searchTerm,
  });

  const base = useBaseEntityList();

  const data = useMemo((): SearchEntityListData | null => {
    if (!queryResult.data) {
      return null;
    }

    const { items } = queryResult.data;

    return {
      items: items.map(entity => ({
        ...entity,
        lastModified: entity.lastModified
          ? moment(entity.lastModified).format('MMM. D, YYYY')
          : null,
      })),
    };
  }, [queryResult.data]);

  return {
    ...queryResult,
    data,
    ...base,
  };
};
